module.exports = __webpack_public_path__ + "static/img/state-grid_15.da49e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-home/state-grid_15.png
// module id = Vkmh
// module chunks = 1